module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTYgOTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGlkPSJJY29uc19CYWNrX1JUTCIgb3ZlcmZsb3c9ImhpZGRlbiI+PHBhdGggZD0iTTg4IDQzIDU5LjQgMTkgNTkuNCAzM0MxNS41IDMzLjQgOCA3OCA4IDc4IDggNzggMjQuMyA1NC4zIDU5LjQgNTRMNTkuNCA2NyA4OCA0M1oiIGZpbGw9IiNGRjAwMDAiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/card2-10.svg
// module id = why3
// module chunks = 1